export const getURLLink = website =>
  website && website.startsWith('https') ? website : `https://${website}`;

export const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export const getEmployer = (id, employers) => id ? employers.find(emp => emp.id === id) : ''